import React, { useState } from 'react';

import Button from 'CommonComponents/Button';
import FormInput from 'CommonComponents/FormInput';

/**
 * One name field that suggests the standard sports. Picking one adds that
 * sport; any other name adds a custom event. Enter saves, Escape cancels.
 *
 * onSubmit receives {sport_id} or {name} and returns a promise; a validation
 * rejection is shown under the field.
 */
export default function AddEventForm({ defaultSports, onSubmit, onCancel }) {
    const [value, setValue] = useState('');
    const [error, setError] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const submit = (e) => {
        e.preventDefault();

        const name = value.trim();
        if (!name) {
            setError($t('Name is required'));

            return;
        }

        const standard = defaultSports.find((sport) => sport.name.toLowerCase() === name.toLowerCase());

        setSubmitting(true);
        setError('');

        onSubmit(standard ? { sport_id: standard.id } : { name })
            .catch((err) => {
                const errors = err?.response?.data?.errors;
                if (errors) {
                    setError(Object.values(errors).flat().join(' '));
                }
            })
            .finally(() => setSubmitting(false));
    };

    return (
        <form
            className="tw-flex tw-items-start tw-gap-2 tw-w-full tw-max-w-2xl tw-px-4 tw-py-3 tw-rounded-lg tw-border tw-border-charcoal-15 tw-bg-background"
            onSubmit={submit}
        >
            <div className="tw-flex-1">
                <FormInput
                    id="setup-wizard-new-event"
                    name="setup-wizard-new-event"
                    type="text"
                    label={$t('Event name')}
                    hideLabel={true}
                    aria-label={$t('Event name')}
                    placeholder={$t('Pick a standard sport or type a name')}
                    list="setup-wizard-default-sports"
                    maxLength={191}
                    autoFocus
                    autoComplete="off"
                    value={value}
                    readOnly={submitting}
                    showError={!!error}
                    errorText={error}
                    onKeyDown={(e) => {
                        if (e.key === 'Escape') {
                            e.preventDefault();
                            onCancel();
                        }
                    }}
                    onChange={(e) => {
                        setError('');
                        setValue(e.target.value);
                    }}
                />
                <datalist id="setup-wizard-default-sports">
                    {defaultSports.map((sport) => (
                        <option key={sport.id} value={sport.name} />
                    ))}
                </datalist>
            </div>
            <Button type="submit" variant="primary" small loading={submitting} disabled={submitting}>
                {$t('Save')}
            </Button>
            <Button variant="outline" small disabled={submitting} onClick={onCancel}>
                {$t('Cancel')}
            </Button>
        </form>
    );
}
